import { useMemo } from 'react';
import { SelectableTableColumn } from '../../../../components/SelectableTable/SelectableTable.types';
import { useTranslation } from 'react-i18next';

export const useExaminerTreemapTableColumns = () => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = useMemo(
    () => [
      {
        id: 'taskGroupName',
        type: 'text',
        title: t('examinersTreemap:table.taskGroupName'),
        filterType: 'filter',
      },
      {
        id: 'function',
        type: 'text',
        title: t('examinersTreemap:table.function'),
        filterType: 'filter',
      },
      {
        id: 'firstName',
        type: 'text',
        title: t('examinersTreemap:table.firstName'),
        filterType: 'search',
      },
      {
        id: 'lastName',
        type: 'text',
        title: t('examinersTreemap:table.lastName'),
        filterType: 'search',
      },
      {
        id: 'examinerNumber',
        type: 'text',
        title: t('examinersTreemap:table.examinerNumber'),
        filterType: 'search',
      },
      {
        id: 'examCommittee',
        type: 'text',
        title: 'Komisja',
        filterType: 'filter',
        sortable: true,
      },
      {
        id: 'actions',
        type: 'actions',
        title: 'Akcje',
        filterType: null,
        skipEnterMethod: true,
      },
    ],
    [t],
  );

  return {
    columns,
  };
};
